export const stamp = (theme) => ({
    stamp: {
        color: "#fff",
        backgroundColor: theme.customPalette.black,
        ...theme.fonts.faces.bodyM,
        width: 68,
        height: 68,
        borderRadius: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        lineHeight: 1,
        fontSize: 14,
        position: "absolute",
    },
});
